export default __webpack_public_path__ + "static/media/cart.c0d9d244.svg";